<!-- ORGANISM: AccountMenuCard.vue -->
<!-- Dropdown card shown inside the account menu — heading, language switcher, and sign-out button. -->

<script setup lang="ts">
//
// Imports
//
import AccountMenuCardHeading from "../molecules/AccountMenuCardHeading.vue";
import AccountMenuCardLanguage from "../molecules/AccountMenuCardLanguage.vue";
import AccountMenuCardSignOut from "../molecules/AccountMenuCardSignOut.vue";

//
// Props & Emits
//
defineProps<{
  userName: string;
  userEmail: string;
  userInitials: string;
  logout: () => void;
}>();
</script>

<template>
  <v-card width="20rem" rounded="lg" elevation="10" class="bg-primary text-white pb-2">
    <!-- Heading -->
    <AccountMenuCardHeading :user-name="userName" :user-email="userEmail" :user-initials="userInitials" />

    <!-- Language -->
    <AccountMenuCardLanguage />

    <!-- Sign Out -->
    <AccountMenuCardSignOut :logout="logout" />
  </v-card>
</template>
